import React, { useState } from 'react';

import { Modal } from '@wds/modal';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';

import PropTypes from 'prop-types';
import MFA from '../Authentication/MFA';
import RecoveryEmailChallengeModal from './RecoveryEmailChallengeModal';

import STRINGS from '../../constants';

const ChangeMFADeviceModal = (props) => {
	const {
		open,
		context,
		setContext,
		handleClose,
	} = props;

	const [showChangeDevice, setShowChangeDevice] = useState(false);
	const [showRecoveryModal, setShowRecoveryModal] = useState(false);
	const [recoveryNewMethod, setRecoveryNewMethod] = useState('totp');

	const handleChangeDevice = () => {
		setShowChangeDevice(true);
	};

	const handleOpenRecoveryModal = (newMethod) => {
		setRecoveryNewMethod(newMethod);
		setShowRecoveryModal(true);
	};

	const handleRecoverySuccess = (changeData) => {
		console.log('[ChangeMFADeviceModal] Recovery success, updating context with:', changeData);
		// Close the recovery modal
		setShowRecoveryModal(false);
		
		// Update context with the device change data
		let newContext = { ...context };
		if (changeData.method.method === 'totp') {
			newContext = {
				...newContext,
				challengeCode: '',
				new_method: recoveryNewMethod,
				method_id: changeData.method.id,
				qrCodeString: changeData.qr_code,
				securityKeyString: changeData.secret,
				changeInProgress: true,
			};
		} else if (changeData.method.method === 'email') {
			newContext = {
				...newContext,
				challengeCode: '',
				new_method: recoveryNewMethod,
				method_id: changeData.method.id,
				status: 'code_pending',
				changeInProgress: true,
			};
		}
		console.log('[ChangeMFADeviceModal] New context:', newContext);
		setContext(newContext);
	};

	return (
		<Box id='sma-change-mfa-device-modal'>
			<Modal
				show={open}
				data-testid='change-mfa-device-modal'
				onClose={handleClose}
			>
				{!showChangeDevice && (
					<Modal.Header header={STRINGS.changeMFADevice} />
				)}
				<Modal.Body>
					{showChangeDevice && (
						<Box id='sma-mfa-enrollment-modal'>
							<MFA 
								context={context} 
								setContext={setContext} 
								isModal 
								handleClose={handleClose} 
								isChange 
								onOpenRecoveryModal={handleOpenRecoveryModal}
							/>
						</Box>
					)}
				{!showChangeDevice && (
					<Typography component='p' variant='bodySm' style={{ whiteSpace: 'pre-line' }}>
						{STRINGS.changeMFADeviceMessage}
					</Typography>
				)}
				</Modal.Body>
				{!showChangeDevice && (
					<Modal.Footer align='right'>
						<Button
							onClick={() => handleClose()}
							id='sma-cancel-button'
							aria-label={STRINGS.cancel}
							variant='text'
						>
							{STRINGS.cancel}
						</Button>
						<Button
							onClick={() => handleChangeDevice()}
							id='sma-change-device-button'
							aria-label={STRINGS.changeDevice}
						>
							{STRINGS.changeDevice}
						</Button>
					</Modal.Footer>
				)}
			</Modal>

			{/* Recovery Email Challenge Modal - Rendered outside main modal */}
			<RecoveryEmailChallengeModal
				open={showRecoveryModal}
				handleClose={() => setShowRecoveryModal(false)}
				onSuccess={handleRecoverySuccess}
				newMethod={recoveryNewMethod}
			/>
		</Box>
	);
};

ChangeMFADeviceModal.propTypes = {
	open: PropTypes.bool.isRequired,
	setContext: PropTypes.func.isRequired,
	handleClose: PropTypes.func.isRequired,
};

export default ChangeMFADeviceModal;
